module.exports = __webpack_public_path__ + "static/media/5.19df8969.jpg";